import { Layer, ManagedRuntime } from 'effect';
import { CognitoHttpClient } from 'services/httpClient';
import Api, { ThirdPartyApi } from 'services/api';

// add other layers that should be available by default
export const ServiceLayer = Layer.mergeAll(
  CognitoHttpClient.Live,
  CognitoHttpClient.ThirdParty,
  Api.Default,
  ThirdPartyApi.Default,
);

export type LiveManagedRuntime = ManagedRuntime.ManagedRuntime<Layer.Layer.Success<typeof ServiceLayer>, never>;
